import {Product} from "@app/core/product/domain/dtos/product";
import {PriceMapper} from "@app/core/shared/infrastructure/mappers/price.mapper";

export class ProductMapper {
    static deserialize(param: any): Product {
        return {
            code: String(param.code).trim(),
            name: param.name,
            units: param.units ?? param.unitsBox,
            price: PriceMapper.deserialize(param.priceBox),
            unitPrice: PriceMapper.deserialize(param.priceUnit) ?? PriceMapper.deserialize(param.unit_price),
            image: param.imageUrl ?? param.image_small,
            palletPrice: param.paletPrice,
            isNew: param.new ?? false,
            isTopProducts: param.top ?? false,
            isPromotion: param.is_promotion ?? false,
            isFavorite: param.fav ?? false,
            hasStock: param.hasStock ?? undefined,
        }
    }
}
